.mdn {
    &[data-variant="default"] {
        max-width: 18rem;
        background: none;
        border: 1px solid var(--mantine-color-gray-3);
    }
}
